import React, {Component} from "react";
import NavbarComponent from "../components/NavbarComponent";
import CoursesTable from "../components/tables/CoursesTable";

class CoursesPage extends Component {

    render() {
        return(
            <div>
                <NavbarComponent initValue={"/courses"}/>
                <CoursesTable/>
            </div>
        );
    }
}

export default CoursesPage;